module.exports = __webpack_public_path__ + "static/media/ibd_neck1.5abe6bf2.png";